import React from 'react';
import styled from '@emotion/styled';

import { Alert } from '../../../../main/scripts/lumen';
import { miscErrMsg, ssoHasFailed } from './utils';

export const Alerts = ({ showLoginToContinuePrompt, loginErrorMessage }) => {
  const ssoError = ssoHasFailed();
  const showLoginError = loginErrorMessage !== '';

  if (!showLoginToContinuePrompt && !showLoginError && !ssoError) {
    return null;
  }

  return (
    <Stack>
      {showLoginToContinuePrompt && (
        <Alert variant="info">Please log in to continue.</Alert>
      )}
      {(showLoginError || ssoError) && (
        <Alert variant="danger">{loginErrorMessage || miscErrMsg}</Alert>
      )}
    </Stack>
  );
};

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;
